/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { Button, Tippy } from '@superops/ui-design-system';
import {
  getTranslatedText,
  CustomWarningModal,
  ALL_SHARD_MODULES
} from '@nile/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';

const ActionCell = ({ cell }: { cell: any }) => {
  const flags = useFlags();
  const intl = useIntl();
  const data = cell?.row?.original;
  const { actions, module, editable, deleteable } = cell?.column;

  if (!actions) {
    return null;
  }

  let infoText = {
    inactive: {
      title: 'app.common.mark.inactive',
      description: 'admin.fields.make.inActive.warning.description'
    },
    delete: {
      title: 'admin.fields.delete.warning.title',
      description: 'admin.fields.delete.warning.description'
    }
  };

  if (module === ALL_SHARD_MODULES.invoice) {
    infoText = {
      inactive: {
        title: 'invoice.custom.field.mark.inactive.title',
        description: 'invoice.custom.field.mark.inActive.warning.description'
      },
      delete: {
        title: 'invoice.custom.field.delete.warning.title',
        description: 'invoice.custom.field.delete.warning.description'
      }
    };
  }

  return actions?.checkDeleteItemAllowPermission(data) ? (
    <div className="fx actr g5">
      {editable && data?.fieldCategory === 'CUSTOM' ? (
        data?.status === 'ACTIVE' ? (
          <CustomWarningModal
            modalActivator={
              <Tippy
                title={getTranslatedText(intl, 'app.common.mark.inactive')}
                position="top"
                trigger="mouseenter"
                theme="dark"
                delay={100}
              >
                <span className="action-cell-text ptr">
                  <SVGIcon name="Restrict" />
                </span>
              </Tippy>
            }
            primaryBtnText={getTranslatedText(intl, 'app.common.mark.inactive')}
            onConfirmation={() => actions?.toggleFieldStatus(data)}
            content={
              <div className="fx fcol g5 wm-550">
                <div className="fx actr g20">
                  <SVGIcon name="WarningIcon" color="#F6C05E" size="lg" />
                  <span className="f-24 font-weight-600">
                    <FormattedMessage id={infoText?.inactive?.title} />
                  </span>
                </div>
                <div className="pl-44 word-break mt-5">
                  <FormattedMessage
                    id={infoText?.inactive?.description}
                    values={{
                      fieldName: data?.label || data?.columnName
                    }}
                  />
                </div>
              </div>
            }
          />
        ) : (
          <Tippy
            title={getTranslatedText(intl, 'app.common.restore')}
            position="top"
            trigger="mouseenter"
            theme="dark"
            delay={100}
          >
            <span
              className="action-cell-text ptr"
              onClick={() => actions?.toggleFieldStatus(data)}
            >
              <SVGIcon name="Revert" />
            </span>
          </Tippy>
        )
      ) : null}
      {flags?.deleteCustomFields && deleteable && (
        <CustomWarningModal
          modalActivator={
            <Tippy
              title={getTranslatedText(intl, 'common.delete')}
              position="top"
              trigger="mouseenter"
              theme="dark"
              delay={100}
            >
              <span className="action-cell-text ptr">
                <SVGIcon name="Delete" color="red" />
              </span>
            </Tippy>
          }
          content={
            <div className="fx fcol g5 wm-550">
              <div className="fx actr g10">
                <SVGIcon name="WarningIcon" color="#D44D4D" size="lg" />
                <span className="f-24 font-weight-600">
                  <FormattedMessage id={infoText?.delete?.title} />
                </span>
              </div>
              <div className="pl-44 word-break mt-5">
                <FormattedMessage
                  id={infoText?.delete?.description}
                  values={{
                    fieldName: data?.label || data?.columnName
                  }}
                />
              </div>
            </div>
          }
          primaryBtn={
            <Button
              destructive
              icon={<SVGIcon name="Delete" color="#de3730" />}
            >
              <FormattedMessage id="common.delete" />
            </Button>
          }
          onConfirmation={() => actions?.deleteField(data)}
        />
      )}
    </div>
  ) : null;
};

export default ActionCell;
